import { down } from "assets/icons/index";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {
  ABOUT_PATH,
  BOARD_OF_DIRECTORS_PATH,
  CONTACT_US_PATH,
  EXTERNAL_PROJECTS_PATH,
  HUMANITARIAN_CASES_PATH,
  INTERNAL_PROJECTS_PATH,
  NEWS_PATH,
  ORGANIZATIONAL_STRUCTURE_PATH,
  ORPHAN_SPONSORSHIP_PATH,
  OUR_ACHIEVEMENTS_PATH,
  SEASONAL_PROJECTS_PATH,
  VIDEOS_PATH,
  VISION_AND_MISSION_PATH,
} from "Routes/paths";
import { getExternalProjectsCategoriesActions } from "redux/actions/ExternalProjects/getExternalProjectsCategoriesActions";

const NavBar = () => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();
  return (
    <div
      className={`hidden w-full h-full lg:flex items-center justify-around font-${
        i18n.language === "en" ? "Poppins" : "Almarai"
      } font-[600] text-[12px] xl:text-[14px]`}
    >
      <p className="h-full flex items-center gap-2 relative group  cursor-pointer">
        {t("Our Organization")} <img src={down} alt="" />
        {/* DropDown */}
        <div
          className={
            i18n.language === "en"
              ? "hidden group-hover:block w-[300px] p-[18px] absolute left-[-70%] xl:left-[-50%] top-[100%] bg-white border-[1px]  rounded-[15px] shadow-lg"
              : "hidden group-hover:block w-[240px] p-[18px] absolute right-[-70%] xl:right-[-50%] top-[100%] bg-white border-[1px]  rounded-[15px] shadow-lg"
          }
        >
          <div
            className={`font-${
              i18n.language === "en" ? "Poppins" : "Almarai"
            } font-[600] text-[14px] flex flex-col gap-2`}
          >
            <Link
              to={ABOUT_PATH}
              className="hover:text-first_color duration-300"
            >
              {t("About Al Etihad Charity Foundation")}
            </Link>
            <Link
              to={VISION_AND_MISSION_PATH}
              className="hover:text-first_color duration-300"
            >
              {t("Vision And Mission")}
            </Link>
            {/* <Link
              to={ORGANIZATIONAL_STRUCTURE_PATH}
              className="hover:text-first_color duration-300"
            >
              {t("Organizational Structure")}
            </Link> */}
            <Link
              to={BOARD_OF_DIRECTORS_PATH}
              className="hover:text-first_color duration-300"
            >
              {t("Board of Directors")}
            </Link>
            <Link
              to={OUR_ACHIEVEMENTS_PATH}
              className="hover:text-first_color duration-300"
            >
              {t("Our Achievements")}
            </Link>

            <Link
              to={CONTACT_US_PATH}
              className="hover:text-first_color duration-300"
            >
              {t("Contact Us")}
            </Link>
          </div>
        </div>
      </p>
      <p className="h-full flex items-center gap-2 relative group cursor-pointer">
        {t("Charity Projects")}
        <img src={down} alt="" />
        {/* DropDown */}
        <div className="hidden group-hover:block w-[200px] p-[18px] absolute left-[-70%] xl:left-[-25%] top-[100%] bg-white border-[1px]  rounded-[15px] shadow-lg">
          <div
            className={`font-${
              i18n.language === "en" ? "Poppins" : "Almarai"
            } font-[600] text-[14px] flex flex-col gap-2`}
          >
            <Link
              to={INTERNAL_PROJECTS_PATH}
              className="hover:text-first_color duration-300"
            >
              {t("Internal Projects")}
            </Link>
            <Link
              to={SEASONAL_PROJECTS_PATH}
              className="hover:text-first_color duration-300"
            >
              {t("Seasonal Projects")}
            </Link>
            {/* <Link
              onClick={() => {
                dispatch(getExternalProjectsCategoriesActions(1, 10));
              }}
              to={EXTERNAL_PROJECTS_PATH}
              className="hover:text-first_color duration-300"
            >
              {t("External Projects")}
            </Link> */}
          </div>
        </div>
      </p>
      <Link
        to={HUMANITARIAN_CASES_PATH}
        className="hover:text-first_color duration-300"
      >
        {t("Humanitarian Cases")}
      </Link>
      <Link
        to={ORPHAN_SPONSORSHIP_PATH}
        className="hover:text-first_color duration-300"
      >
        {t("Orphans Sponsorship")}
      </Link>
      <p className="h-full flex items-center gap-2 relative group cursor-pointer">
        {t("Media Center")}
        <img src={down} alt="" />
        {/* DropDown */}
        <div className="hidden group-hover:block w-[200px] p-[18px] absolute left-[-70%] xl:left-[-50%] top-[100%] bg-white border-[1px]  rounded-[15px] shadow-lg">
          <div
            className={`font-${
              i18n.language === "en" ? "Poppins" : "Almarai"
            } font-[600] text-[14px] flex flex-col gap-2`}
          >
            <Link
              to={NEWS_PATH}
              className="hover:text-first_color duration-300"
            >
              {t("News")}
            </Link>
            <Link
              to={VIDEOS_PATH}
              className="hover:text-first_color duration-300"
            >
              {t("Videos")}
            </Link>
          </div>
        </div>
      </p>
    </div>
  );
};

export default NavBar;
